import {
  WILLS_V3_10,
  WILLS_V3_11,
  WILLS_V3_12,
  WILLS_V3_13,
} from 'lib/@getethos/experiments/constants'
import { useDecisionForFlag } from 'lib/FeaturesAndExperiments/getDecisionForFlag'

import { UsState } from '@/components/EstimateWidget/FloatingVariation/FloatingForm/experiments/FinalExpenseInfoForm/utils/constants'

const WILLS_V3_9_FLOW = 'wills-v3-9'

const WILLS_V3_10_CONTROL_FLOW = 'wills-v3-10-control'
const WILLS_V3_10_TREATMENT_1_FLOW = 'wills-v3-10-treatment-1'

const WILLS_V3_11_CONTROL_FLOW = 'wills-v3-11-control'
const WILLS_V3_11_TREATMENT_1_FLOW = 'wills-v3-11-treatment-1'

export const WILLS_V3_12_CONTROL_FLOW = 'wills-v3-12-control'
export const WILLS_V3_12_TREATMENT_1_FLOW = 'wills-v3-12-treatment-1'
export const WILLS_V3_12_TREATMENT_2_FLOW = 'wills-v3-12-treatment-2'

export const WILLS_V3_12_FLOWS = [
  WILLS_V3_12_CONTROL_FLOW,
  WILLS_V3_12_TREATMENT_1_FLOW,
  WILLS_V3_12_TREATMENT_2_FLOW,
]

export const WILLS_V3_13_CONTROL_FLOW = 'wills-v3-13-control'
export const WILLS_V3_13_TREATMENT_1_FLOW = 'wills-v3-13-treatment-1'
export const WILLS_V3_13_TREATMENT_2_FLOW = 'wills-v3-13-treatment-2'

export const ATTORNEY_REVIEW_ELIGIBLE_STATES = [
  UsState.CA,
  UsState.OH,
  UsState.TX,
  UsState.FL,
  UsState.CO,
  UsState.GA,
  UsState.NJ,
]

const VARIATION_MAP: Record<string, Record<string, string>> = {
  [WILLS_V3_11.EXPERIMENT_KEY]: {
    [WILLS_V3_11.VARIATIONS.CONTROL]: WILLS_V3_11_CONTROL_FLOW,
    [WILLS_V3_11.VARIATIONS.TREATMENT_1]: WILLS_V3_11_TREATMENT_1_FLOW,
  },
  [WILLS_V3_12.EXPERIMENT_KEY]: {
    [WILLS_V3_12.VARIATIONS.CONTROL]: WILLS_V3_12_CONTROL_FLOW,
    [WILLS_V3_12.VARIATIONS.TREATMENT_1]: WILLS_V3_12_TREATMENT_1_FLOW,
    [WILLS_V3_12.VARIATIONS.TREATMENT_2]: WILLS_V3_12_TREATMENT_2_FLOW,
  },
  [WILLS_V3_10.EXPERIMENT_KEY]: {
    [WILLS_V3_10.VARIATIONS.CONTROL]: WILLS_V3_10_CONTROL_FLOW,
    [WILLS_V3_10.VARIATIONS.TREATMENT_1]: WILLS_V3_10_TREATMENT_1_FLOW,
    [WILLS_V3_10.VARIATIONS.WILLS_V3_9]: WILLS_V3_9_FLOW,
  },
  [WILLS_V3_13.EXPERIMENT_KEY]: {
    [WILLS_V3_13.VARIATIONS.CONTROL]: WILLS_V3_13_CONTROL_FLOW,
    [WILLS_V3_13.VARIATIONS.TREATMENT_1]: WILLS_V3_13_TREATMENT_1_FLOW,
    [WILLS_V3_13.VARIATIONS.TREATMENT_2]: WILLS_V3_13_TREATMENT_2_FLOW,
  },
}

export const useWillsFunnelFlow = () => {
  const exp11 = useDecisionForFlag({
    name: WILLS_V3_11.EXPERIMENT_KEY,
    fallbackVariation: WILLS_V3_11.VARIATIONS.CONTROL,
  })

  const exp12 = useDecisionForFlag({
    name: WILLS_V3_12.EXPERIMENT_KEY,
    fallbackVariation: WILLS_V3_12.VARIATIONS.CONTROL,
  })

  const exp10 = useDecisionForFlag({
    name: WILLS_V3_10.EXPERIMENT_KEY,
    fallbackVariation: WILLS_V3_10.VARIATIONS.CONTROL,
  })
  const exp13 = useDecisionForFlag({
    name: WILLS_V3_13.EXPERIMENT_KEY,
    fallbackVariation: WILLS_V3_13.VARIATIONS.CONTROL,
  })

  // experiments are sorted by priority
  const experiments = [
    {
      isEnabled: exp13.isEnabled,
      key: WILLS_V3_13.EXPERIMENT_KEY,
      variation: exp13.variation,
    },
    {
      isEnabled: exp12.isEnabled,
      key: WILLS_V3_12.EXPERIMENT_KEY,
      variation: exp12.variation,
    },
    {
      isEnabled: exp11.isEnabled,
      key: WILLS_V3_11.EXPERIMENT_KEY,
      variation: exp11.variation,
    },
    {
      isEnabled: exp10.isEnabled,
      key: WILLS_V3_10.EXPERIMENT_KEY,
      variation: exp10.variation,
    },
  ]
  const activeExperiment = experiments.find((exp) => exp.isEnabled)

  const flow =
    activeExperiment && activeExperiment.variation
      ? VARIATION_MAP[activeExperiment.key]?.[activeExperiment.variation]
      : undefined

  return {
    isLoading:
      exp10.isLoading || exp11.isLoading || exp12.isLoading || exp13.isLoading,
    isTreatment: !!flow,
    isLeadForm: false,
    flow,
    controlFlow: WILLS_V3_12_CONTROL_FLOW,
  }
}
